//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ApplicationManagement',
  components: {},
  data() {
    return {
      appid: this.$route.query.appid,
      menuList: [
        {
          name: '版本管理',
          path: 'mini-verson-detail',
          query: { active: 'first' },
        },
        {
          name: '提审记录',
          path: 'mini-arraignment-record',
        },
        {
          name: '代码草稿箱',
          path: 'mini-draft',
        },
        {
          name: '小程序模板库',
          path: 'mini-program-template',
        },
        {
          name: 'ext_json',
          path: 'mini-ext-json-list',
        },
      ],
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
